<template>
  <v-container fluid>
    <div class="my-5">
      <p>1. <span class="warning--text"> Go to domains and create the domain of the client</span></p>
      <p>2. <span class="warning--text"> Select the new domain, give a name and create the client</span></p>
    </div>
    <div class="my-5">Create A New Client</div>
    <v-row>
      <v-col md="4">
        <v-combobox
          v-model="selected_domain"
          :items="domains_list"
          label="Select Client's Domain"
          item-text="domain"
          item-value="id"
        ></v-combobox>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="4">
        <v-text-field
          v-model="client_name"
          label="Client Name"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-btn
      :disabled="client_name.length < 4 || !selected_domain || create_loader"
      color="success"
      :loading="create_loader"
      @click="create_client"
    >Create Client</v-btn>
  </v-container>
</template>

<script>
/* eslint-disable */

export default {
  name: "create-client",
  data() {
    return {
      client_name: '',
      selected_domain: 0,
      create_loader: false
    };
  },
  computed: {
    domains_list() {
      return this.$store.state.productionModule.domains;
    },
  },
  methods: {
    create_client() {
      console.log('create client', this.selected_domain, this.client_name,)
      this.create_loader = true;
      const params = {
        task: "create_client",
        payload: {
          domain_id: this.selected_domain,
          client_name: this.client_name,
        },
      };
      this.$store
        .dispatch("productionModule/general_api", params)
        .then((res) => {
          const data = res.data.payload;
          console.log("create_client", data);
          const message = res.data.message;
          this.$emit('snackbar_show',{text: message})
        })
        .catch((err) => console.log("error", err))
        .finally(() => {this.create_loader = false;})
    },
  },
  watch: {
    // 'new_domain'(newValue, oldValue) {
    //   if ( newValue && newValue.length > 2 && newValue !== oldValue ) {
    //     this.check_domain();
    //   }
    // },
  },
  created() {
    // this.loadDomains();
    // this.domain = Object.assign({}, this.domain_init);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/admin/Clients.vue